import { useDispatch, useSelector } from "react-redux";
import "./region.scss";
import { ArrowRight } from "react-feather";
import { AppColors } from "../../consts/colors";
import { setActiveRegion } from "../../store/features/globalSlice";
import { ROUTES } from "../../routes";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useState } from "react";
import { Spinner } from "../../components/Spinner";
import { setCurrentUser } from "../../store/features/authSlice";
import { REGION_NAME_LIST } from "../../consts/AppContants";

const RegionSelect = () => {
  const regions = useSelector((s) => s.global.regions);
  const currentUser = useSelector((s) => s.auth.currentUser);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useAuth();

  const handleRegionSelection = async (region) => {
    setLoading(true);

    dispatch(setActiveRegion(region.region));
    dispatch(setCurrentUser({ ...currentUser, ...region }));

    const client = await auth.fetchClientDetails();

    if (client) {
      setLoading(false);
      return navigate(ROUTES.DASHBOARD, {
        replace: true,
      });
    }
    return navigate(ROUTES.LOGIN, {
      replace: true,
    });
  };

  return (
    <>
      <div className="region-wrapper">
        <div className="region-selection">
          <h3 className="text-center mb-5 text-muted">
            Hi, {currentUser.firstName}
          </h3>
          <div className="card">
            <div className="card-header py-3 text-center fw-bold">
              <h6 className="m-0 text-uppercase">
                Please Select Region To Continue
              </h6>
            </div>
            <div className="card-body p-0">
              {loading ? (
                <li className="list-group-item list-group-item-action py-5">
                  <Spinner />
                </li>
              ) : (
                <ul className="list-group list-group-flush region-list">
                  {regions.map((item) => (
                    <RegionItem
                      item={REGION_NAME_LIST[item.region]}
                      onClick={() => handleRegionSelection(item)}
                      key={item.region}
                    />
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const RegionItem = ({ item, onClick }) => {
  return (
    <li className="list-group-item list-group-item-action" onClick={onClick}>
      <a
        href="#"
        className="d-flex align-items-center text-decoration-none py-2"
      >
        <img
          src={`https://flagsapi.com/${item?.code}/flat/32.png`}
          alt={item.name}
        />
        <span className="fw-bold ms-3 ">{item.name}</span>
        <span className="ms-auto">
          <ArrowRight size={16} color={AppColors.grey2} />
        </span>
      </a>
    </li>
  );
};

export default RegionSelect;
